import { PropTypes } from 'prop-types';
import { userDataPropTypes } from './user';

export const auditDataDeserialiser = (original) => ({
  alignmentLastUpdatedBy: {
    emailAddress: original?.alignment_last_updated_by?.email_address || '',
    userId: original?.alignment_last_updated_by?.user_id || '',
  },
  alignmentStatusLastUpdatedAt: original?.alignment_status_last_updated_at,
  alignmentStatusLastUpdatedBy: {
    emailAddress:
      original?.alignment_status_last_updated_by?.email_address || '',
    userId: original?.alignment_status_last_updated_by?.user_id || '',
  },
  doNotUseLastUpdatedAt: original?.do_not_use_last_updated_at,
  doNotUseLastUpdatedBy: {
    emailAddress: original?.do_not_use_last_updated_by?.email_address || '',
    userId: original?.do_not_use_last_updated_by?.user_id || '',
  },
  lastUpdatedAt: original?.last_updated_at,
  lastUpdatedBy: {
    emailAddress: original?.last_updated_by?.email_address || '',
    userId: original?.last_updated_by?.user_id || '',
  },
  offsetsLastUpdatedAt: original?.offsets_last_updated_at,
  offsetsLastUpdatedBy: {
    emailAddress: original?.offsets_last_updated_by?.email_address || '',
    userId: original?.offsets_last_updated_by?.user_id || '',
  },
  sourceDataLastUpdatedAt: original?.source_data_last_updated_at,
  sourceDataLastUpdatedBy: {
    emailAddress: original?.source_data_last_updated_by?.email_address || '',
    userId: original?.source_data_last_updated_by?.user_id || '',
  },
});

export const auditDataPropTypes = {
  doNotUseLastUpdatedAt: PropTypes.string.isRequired,
  doNotUseLastUpdatedBy: PropTypes.shape(userDataPropTypes).isRequired,
  lastUpdatedAt: PropTypes.string.isRequired,
  lastUpdatedBy: PropTypes.shape(userDataPropTypes).isRequired,
  offsetsLastUpdatedAt: PropTypes.string,
  offsetsLastUpdatedBy: PropTypes.shape(userDataPropTypes).isRequired,
  sourceDataLastUpdatedAt: PropTypes.string,
  sourceDataLastUpdatedBy: PropTypes.shape(userDataPropTypes).isRequired,
};
